import { render, staticRenderFns } from "./InvitesTable.vue?vue&type=template&id=3c273dc4&"
import script from "./InvitesTable.vue?vue&type=script&lang=js&"
export * from "./InvitesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports